window.GsBase = window.GsBase || {};
var occupCertPop;
var pwdFailPop;
var reCAPTCHA_1_token = "";
var reCAPTCHA_1_encToken = "";
var reCAPTCHA_1_result = "";
var reCAPTCHA_2_token = "";
var progress = false;
var reCAPTCHprogress = false;
(function ($, global, GsBase) {
	
	GsBase.noMemord = {};//비회원주문 
	$("#kakaoLogin").click(function e(){
		global.logLseq("416198");
		var captchaFlg = $("#captchaFlg").val();
		var confirmNumber = $("#confirmNumber").val();
		if(captchaFlg === "true"){
			GsBase.noMemord.reset();
			gs.captchaShow();
        	$("#captchaLoginType").val('ka');
        	return false;
		}
		else{
			setReturnUrlCookie();
			grmGatePopup("KAKAO");
		}
	});
	
	$("#confirmNum").on("keydown",function (e){
		if (e.keyCode === 13){
			e.preventDefault();
			goCaptchaLogin();
		}
	});
	
	
	//SNS 로그인 링크
	$("#naverLogin").click(function e(){
		global.logLseq("416197");
		var captchaFlg = $("#captchaFlg").val();
		var confirmNumber = $("#confirmNumber").val();
		if(captchaFlg === "true"){
			GsBase.noMemord.reset();
			gs.captchaShow();
			
        	$("#captchaLoginType").val('na');
        	return false;
			
		}
		else{
			setReturnUrlCookie();
			grmGatePopup("NAVER");
		}
	});
	$("#idSrch").click(function e(){
		global.logLseq("416204");
		grmGate("FINDID");
	});
	$("#pwSrch").click(function e(){
		global.logLseq("416205");
		grmGate("FINDPW");
	});
	
	$("#btnIdSave").click(function e(){
		global.logLseq("416202");
	});
	
	var layerReturn = function(){
		var msg = $("#srchLayer #alertMessage").val();
		
		if(msg){
			alert(msg);
			var srchLayer = new GsBase.modal('#srchLayer');
			srchLayer.remove();
		}
		
	}
	
	$("#tvLogin").click(function e(){
		location.href="/cust/login/tvLogin.gs?returnurl="+$("#returnurl").val();
	});
	
	$("#noMemOrdQry").click(function e(){
		global.logLseq("416208");
		location.href="/ord/dlvcursta/nomemDlvQry.gs";
	});
	
	$("#noMemOrd").click(function e(){
		
		if($("#noMemOrdCaptchaFlg").val() === 'true'){
			
			GsBase.noMemord.noMemOrdCaptcha(); 
		}else{
			global.logLseq("416209");
			location.href="/cust/login/noMemOrd.gs?returnurl="+$("#returnurl").val();
		}
	});
	
	var setReturnUrlCookie = function(){
		$.ajax({
	        type: "POST",
	        url: "/cust/login/setReturnUrlCookie.gs",
	        async: false,
	        data: {returnurl: $("#retUrl").val()},
	        success: function(result){
	        },
	        error: function(){
	        }
	    });
	}

	var setLoginIdCookie = function(){
		$.ajax({
			type: "POST",
			url: "/cust/login/setLoginIdCookie.gs",
			async: false,
			data: {loginId: $("#id").val()},
			success: function(result){
			},
			error: function(){
			}
		});
	}
	
	GsBase.login = {};
	GsBase.login.submit = function(){
		setReturnUrlCookie();
		setLoginIdCookie();
		if($("#btnIdSave").is(":checked")){
			$("#autoIdFlg").val("1");
		} else {
			$("#autoIdFlg").val("0");
		}
		
		const el = document.createElement("span");
		el.style.all = "unset";
		el.style.fontFamily = "initial";
		document.body.appendChild(el);
		$("#commonRegLogin").append( $('<input>', { type: 'hidden', id: "ft", name: "ft", val: btoa(unescape(encodeURIComponent((getComputedStyle(el).fontFamily)))) }) );
		document.body.removeChild(el);
		
		progress = true;
		$("#commonRegLogin").submit();
	};
	
	GsBase.login.capchaShowOrSubmit = function(){
		if($("#captchaFlg").val() === "true"){
			GsBase.noMemord.reset();
			gs.captchaShow();
		} else {
			GsBase.login.submit();
		}
	};
	
	$("#btnLogin").click(function (){
		global.logLseq("416201");
		
		// GRIT-280740 통합 공지 - 로그인 불가 공지 등록 시 로그인 못함
		$.ajax({
	        data:{"gbn":"LGN"},
			type:"POST",
	        url: '/cust/grm/serviceCheckForGrmGbn.gs',
	        success: function (result) {
				if(result && result.contents){
					alert(result.contents.replace(/<br>/gi, ""));
				} else {
					goLogin();
				}
	        },
	        error: function () {
        		alert("서비스가 원활하지 않습니다. 잠시후 다시 시도해 주세요.");
	        }
	    });
		
		$("#captchaLoginType").val('');
	});
	
	$("#passwd").keydown(function (e){
		if (e.keyCode === 13){
			goLogin();
		}
	}).focus(function (){
		$("#noti_passwd_msg").parent().removeClass("error");
	});
	
	//회원가입클릭
	$("#memJoin").click(function e(){
		global.logLseq("416207");
		grmGate("JOIN");
	});
	
	$("#capchaConfirmBtn").bind("click", function(e){
		e.preventDefault();
		goCaptchaLogin();
	});
	
	var goCaptchaLogin = function(){ 
		
		if(GsBase.noMemord.captchaFlg === true){
			GsBase.noMemord.goCaptchaLogin();
			return;
		}
		
		var captchaFlg = $("#captchaFlg").val();
		var confirmNumber = $("#confirmNum").val();
		$("input[name=confirmNumber]").val(confirmNumber);
		
		 if (confirmNumber === "") {
            $("#noti_confirmNumber_msg").html("보안문자를 정확하게 입력해주세요.");
            $("#noti_confirmNumber_msg").parent().addClass("error");
            return false;
		 }
		 
		 if(confirmNumber.length != 6){
  		    $("#noti_confirmNumber_msg").html("보안문자를 정확하게 입력해주세요.");
            $("#noti_confirmNumber_msg").parent().addClass("error");
            return false;
		 }
		
		var tmpUrl = '/cust/login/getCaptchaChk.gs';
	    
		$.ajax({
	        type:"post",
	        data:{"confirmNumber":confirmNumber},
	        url: tmpUrl,
	        success: function (result) {
	        	if(result === "Y"){
		       		if($("#captchaLoginType").val() === "na"){
		     			setReturnUrlCookie();
						var checkNotice = serviceCheckForGrmGate();
						if(checkNotice) {
							alert(checkNotice.contents);
							return;
						} else {
							window.open(""
									,"grmGatePopup"
									,"width=800, height=600, topmargin=0, leftmargin=0, left=0, top=0, toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes");
							$("#commonRegLoginGrmGate").attr("action", "/cust/grm/gate.gs?page=NAVER&popup=Y");
							$("#commonRegLoginGrmGate").submit();
						}
		     		}else if($("#captchaLoginType").val() === "ka"){
		     			setReturnUrlCookie();
						var checkNotice = serviceCheckForGrmGate();
						if(checkNotice) {
							alert(checkNotice.contents);
							return;
						} else {
							window.open(""
									,"grmGatePopup"
									,"width=800, height=600, topmargin=0, leftmargin=0, left=0, top=0, toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes");
							$("#commonRegLoginGrmGate").attr("action", "/cust/grm/gate.gs?page=KAKAO&popup=Y");
							$("#commonRegLoginGrmGate").submit();
						}
		     		}else{
						GsBase.login.submit();
		     		}
	        	}else{
	        		$("#noti_confirmNumber_msg").parent().addClass("error");
                    $("#noti_confirmNumber_msg").html("보안문자를 정확하게 입력해주세요.").addClass("on");
	        	}
	        },
	        error: function () {
	        	$("#noti_confirmNumber_msg").parent().addClass("error");
	        	$("#noti_confirmNumber_msg").html("시스템 오류로  보안문자 전송에 실패하였습니다. 잠시후 다시 시도해주세요.").addClass("on");
	        }
	    });
	}
	
	var goLogin = function () {
		if(progress) {
			alert("로그인 진행중입니다.");
			return false;
		}
        var $id = $("#id");
        var $passwd = $("#passwd");
        var $confirmNumber = $("#confirmNum");
        var $captchaFlg = $("#captchaFlg");
        
        if ($id.val() === "") {
        	$("#noti_id_msg").html("아이디를 입력해주세요.");
			$("#noti_id_msg").parent().addClass("error");
            return false;
        } else if ($passwd.val() === "") {
        	$("#noti_passwd_msg").html("비밀번호를 입력해주세요.");
			$("#noti_passwd_msg").parent().addClass("error");
            return false;
		
		} else if (reCAPTCHA_1_result === "need" && reCAPTCHA_2_token == ""
			&& $("#reCAPTCHA-chbx iframe").length > 0 && !$("#reCAPTCHA-chbx").hasClass("error")) {
			$("#reCAPTCHA-chbx").addClass("error");
			$("#reCAPTCHA-chbx").append('<em class="err-msg">고객님의 계정 보호를 위해 보안 체크를 확인해 주세요.</em>');
			return false;
			
        } else {
			if($("#reCAPTCHA-chbx").length > 0 && $("#reCAPTCHA-chbx iframe").length == 0) {
				$('#reCAPTCHA-chbx').remove();
				$('#commonRegLogin input[name="reCAPTCHA_1_token"]').remove();
				reCAPTCHA_1_token = "";
				$('#commonRegLogin input[name="reCAPTCHA_1_encToken"]').remove();
				reCAPTCHA_1_encToken = "";
				reCAPTCHA_1_result = "";
			}
    		//로그인 페이지 진입 시 redis 확인
    		var tmpUrl = '/cust/login/pwdCntFailChk.gs';
    		$.ajax({
    			type: "GET",
    			data: {"loginId" : $id.val(),
    			 		"encVrfyKey" : $("#encVrfyKey").val()},
    			url: tmpUrl,
    			cache : false,
    			success: function (data) {
					if(data === "B") {
						location.href="/index.gs";
					} else if (data === "S") {
                        location.reload();
					} else {
						if($captchaFlg.val() != "true") {
							if(data === "N") {
								captchaFlgInfo();
							} else if (data === "C") {
								$captchaFlg.val("true");
								captchaFlgInfo();
							} else {
								pwdFailPop = window.open('/cust/login/pwdFailCntCert.gs?loginId='+$id.val(), 'srchLayer', 'width=400,height=630, scrollbars=no');
								if (!pwdFailPop || pwdFailPop === null|| pwdFailPop.closed || typeof pwdFailPop.closed === 'undefined') {
									alert('현재 브라우저에서 팝업이 차단되어 기능이 실행되지 않았습니다.\n\n주소창 오른쪽의 팝업 차단 아이콘을 클릭하여\n이 사이트의 팝업을 허용으로 변경해 주세요.\n\n설정 후 페이지를 새로고침하거나 다시 시도해 주세요.');
								}
							}
						} else {
							if(data === "O") {
								pwdFailPop = window.open('/cust/login/pwdFailCntCert.gs?loginId='+$id.val(), 'srchLayer', 'width=400,height=630, scrollbars=no');
								if (!pwdFailPop || pwdFailPop === null|| pwdFailPop.closed || typeof pwdFailPop.closed === 'undefined') {
									alert('현재 브라우저에서 팝업이 차단되어 기능이 실행되지 않았습니다.\n\n주소창 오른쪽의 팝업 차단 아이콘을 클릭하여\n이 사이트의 팝업을 허용으로 변경해 주세요.\n\n설정 후 페이지를 새로고침하거나 다시 시도해 주세요.');
								}
							} else {
								captchaFlgInfo();
							}
						}
					}
				}
    		});
        }
    };
     
    var captchaFlgInfo = function() {
		if($("#reCaptchaFlg").val() === "true"){
			if(reCAPTCHA_1_result == "need" && reCAPTCHA_2_token != "") {
				GsBase.login.capchaShowOrSubmit();
			} else {
				if(reCAPTCHprogress) {
					return;
				}
				reCAPTCHprogress = true;
				grecaptcha.enterprise.ready(function () {
					grecaptcha.enterprise.execute($("#reCAPTCHA_site_key").val(), { action: 'LOGIN_TRY' }).then(function (token) {
						reCAPTCHA_1_token = token;
						if($('#commonRegLogin input[name="reCAPTCHA_1_token"]').length > 0) {
							$('#commonRegLogin input[name="reCAPTCHA_1_token"]').remove();
						}
						$("#commonRegLogin").append( $('<input>', { type: 'hidden', id: "reCAPTCHA_1_token", name: "reCAPTCHA_1_token", val: reCAPTCHA_1_token }) );
						$.ajax({
							type:"post",
							data:{"token":token, loginId:$("#id").val()},
							url: '/cust/cert/reCAPTCHA/createAssessment.gs',
							async : false,
							success: function (res) {
								if($('#commonRegLogin input[name="reCAPTCHA_1_encToken"]').length > 0) {
									$('#commonRegLogin input[name="reCAPTCHA_1_encToken"]').remove();
								}
								if(res.result === "pass") {
									reCAPTCHA_1_encToken = res.encToken;
									$("#commonRegLogin").append( $('<input>', { type: 'hidden', name: "reCAPTCHA_1_encToken", val: reCAPTCHA_1_encToken }) );
									GsBase.login.capchaShowOrSubmit();
								} else if(res.result === "need") {
									reCAPTCHA_1_encToken = res.encToken;
									reCAPTCHA_1_result = res.result;
									$("#commonRegLogin").append( $('<input>', { type: 'hidden', name: "reCAPTCHA_1_encToken", val: reCAPTCHA_1_encToken }) );
									$("head").append('<script src="https://www.google.com/recaptcha/enterprise.js?onload=onloadReCaptchaCallback&render=explicit" async defer> </script>');
								} else if(res.result === "block") {
									location.href = "/cust/login/login.gs?isLoginFail=Y&returnurl="+$("#returnurl").val();
								} else {
									console.log(res);
									alert("서비스가 원활하지 않습니다. 잠시후 다시 시도해 주세요.");
								}
							},
							error: function () {
								console.log("createAssessment error");
								alert("서비스가 원활하지 않습니다. 잠시후 다시 시도해 주세요.");
							},
							complete: function () {
								reCAPTCHprogress = false;
							}
						});
					})
					.catch(function (error) {
						console.error("reCAPTCHA error:", error);
						alert("서비스가 원활하지 않습니다. 잠시후 다시 시도해 주세요.");
						reCAPTCHprogress = false;
					});
				});
			}
		} else {
			GsBase.login.capchaShowOrSubmit();
		}
		
    }

	
    var bodyOnLoad = function (){
	    if ($("#confirmFlg").val() === "false") {
	        if(captchaFlg === "true"){
	        	GsBase.noMemord.reset();
	        	gs.captchaShow();
	        	$("#noti_confirmNumber_msg").parent().addClass("error");
	        	$("#noti_confirmNumber_msg").html("보안문자를 정확하게 입력해주세요.");
	        }else{
	        	alert("보안문자를 정확하게 입력해주세요.");
	            location.href = "/cust/login/logout.gs?returnurl=/cust/login/login.gs";
	        }
	    }else if( $("#snsFlg").val() !== "" ){ 
	    	var snsFlg = $("#snsFlg").val();
	    	if(snsFlg === "ka_captcha_fail" || snsFlg === "na_captcha_fail"){
	            if(captchaFlg === "true"){
	            	GsBase.noMemord.reset();
	            	gs.captchaShow();
	                $("#noti_confirmNumber_msg").parent().addClass("error");
	                $("#noti_confirmNumber_msg").html("보안문자를 정확하게 입력해주세요.");
	            }else{
	            	alert("보안문자를 정확하게 입력해주세요.");
	                location.href = "/cust/login/logout.gs?returnurl=/cust/login/login.gs";	
	            }
	    		
	    	}
	    }else if($("#loginFailFlg").val() === "Y"){
	        var notiMsg = "아이디 또는 비밀번호를 다시 확인하세요.";
	        var failCnt = $("#failCnt").val();
	        if(isNaN(failCnt)){
	        	failCnt = 0;
	        }
	        if(failCnt >= 3){
	        	notiMsg = "아이디 또는 비밀번호가 틀렸습니다.<br>아이디/비밀번호 찾기를 사용해 보세요~";
	        }
	
	        $("#loginResult").parents("div.input-group").addClass("error");
	        $("#loginResult").html(notiMsg).addClass("on");
	    }
    };
    GsBase.myWindow;
    GsBase.popupCenterOpen = function (popUrl,target,width,height, alertOption){
		
		if(target == null || target == "" ){
			target = "_blank";
		}
		if(width == null || width == "" ){
			width = "1";
		}
		if(height == null || height == "" ){
			height = "1";
		}
		
		
		if(alertOption){
			var tempPop = window.open("about:blank","_temp_popup","width=1,height=1");
			if(tempPop == null){
				alert("화면 상단에 있는 팝업 차단 알림줄을 클릭하여 팝업을 허용해 주시기 바랍니다.");
			}else{
				tempPop.close();
			}
		}
		
		var winL = (screen.width-465)/2;
		var winT = (screen.height-664)/2;
		try{
			if((window.screenLeft!=undefined?window.screenLeft:window.screenX) >= screen.width){
				winL+=screen.width;
			}else if((window.screenLeft!=undefined?window.screenLeft:window.screenX) < 0){
				winL-=screen.width;
			}
		}catch(e){}
		GsBase.myWindow = window.open(popUrl,target,"toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=no,width="+width+",height="+height+",left="+winL+",top="+winT);
	}
    
    //비회원주문하기 - 캡챠체크 20191029 chohj 
    GsBase.noMemord.captchaFlg = false;
    GsBase.noMemord.reset = function (){
    	//캡챠레이어 안내변경
    	$('#modal-capcha-desc').html('안전한 로그인을 위해<br>아래 보안문자를 입력해주세요.');
    	GsBase.noMemord.captchaFlg = false;
    };
    GsBase.noMemord.noMemOrdCaptcha = function (){
    	GsBase.noMemord.captchaFlg = true;
    	
    	//캡챠레이어 안내변경
    	$('#modal-capcha-desc').html('안전한 주문을 위해<br>아래 보안문자를 입력해주세요.');
		gs.captchaShow();
    };
    GsBase.noMemord.goCaptchaLogin = function (){
    	
    	var captchaFlg = $("#captchaFlg").val();
		var confirmNumber = $("#confirmNum").val();
		$("#confirmNumber").val(confirmNumber);
		
		if (confirmNumber === "") {
			$("#noti_confirmNumber_msg").html("보안문자를 정확하게 입력해주세요.");
			$("#noti_confirmNumber_msg").parent().addClass("error");
			return false;
		}
		 
		if(confirmNumber.length != 6){
  		    $("#noti_confirmNumber_msg").html("보안문자를 정확하게 입력해주세요.");
            $("#noti_confirmNumber_msg").parent().addClass("error");
            return false;
		}
		
		$.ajax({
	        type:"post",
	        data:{"confirmNumber":confirmNumber, "typ" : "noMemOrd"},
	        url: '/cust/login/getCaptchaChk.gs',
	        success: function (result) {
	        	if(result === "Y"){
	        		location.href = "/cust/login/noMemOrd.gs?confirmNumber="+confirmNumber+"&returnurl="+$("#returnurl").val();
	        	}else{
	        		$("#noti_confirmNumber_msg").parent().addClass("error");
                    $("#noti_confirmNumber_msg").html("보안문자를 정확하게 입력해주세요.").addClass("on");
	        	}
	        },
	        error: function () {
	        	$("#noti_confirmNumber_msg").parent().addClass("error");
	        	$("#noti_confirmNumber_msg").html("시스템 오류로  보안문자 전송에 실패하였습니다. 잠시후 다시 시도해주세요.").addClass("on");
	        }
	    });
		
    }; //GsBase.noMemord.goCaptchaLogin    
    // HANBOT-14232_SSO/CIAM 배포 1.0
	
	$("#nextBtn").bind("click", function(e){ // 점유인증 안내 팝업 - 다음 버튼
		window.name='loginPage';
		var certPopUrl = '/cust/cert/popup/occupCert.gs?note=' + $("#mode").val() + '&agk=' + $("#agk").val();
		location.href = certPopUrl; 
	});
	
	$("#certModalLayer #closeRfrBtn").bind("click", function(e){// 해외IP/디바이스인증 점유인증 안내 모달 - 닫기 버튼
		if ($("#mode").val() == "frCert" || $("#mode").val() == "offCert") {
			$.ajax({
				type:"post",
				url: '/cust/grm/deleteCookieToken.gs',
				success: function (res) {
				},
				error: function () {
					console.log("deleteCookieToken error");
				}
			});
		}
		GsBase.modal.Event.close('#certModalLayer');
		location.href = "/cust/login/login.gs";
	});
	
	// restrRslt값이 FAIL일 경우 알럿
	if ($("#restrRslt").val() == "FAIL") {
		alert("서비스가 원활하지 않습니다. 잠시후 다시 시도해 주세요.");
	}
}) (jQuery, window, window.GsBase = window.GsBase || {});

//로그인 비밀번호 오류 횟수 제한
//점유인증 완료 후 callBack 함수
function occupCertCallBack(data) {
	if ($("#mode").val() == "frCert" || $("#mode").val() == "dvCert" || $("#mode").val() == "offCert") {
		window.certInfoPop.close();

		if (data.retCd === 'Y') {
			if(data.retMsg != 'frCert' && $("#mode").val() != "offCert") {
				alert("인증이 완료되었습니다.");
			}
			location.href = data.retUrl;
		}
	}
	else {
		loginPwdFailCntLayerClose();
	}
}

function loginPwdFailCntLayerClose() {
	$("#celphnTelno").val("");
	$("#passwd").val("");
	CelphnCert.clearCertNo();
	pwdFailPop.close();
	location.reload();
	return;
}
//리캡챠 체크박스 로드
function onloadReCaptchaCallback() {
	if($("#reCAPTCHA-chbx").length == 0) {
		$(".signup-form").after('<div id="reCAPTCHA-chbx" class="security-code"></div>');
		grecaptcha.enterprise.render(document.getElementById('reCAPTCHA-chbx'), {
			'sitekey' : $("#reCAPTCHA_ckbx_key").val()
			, 'action': 'LOGIN_CHECK'
			, 'callback' : reCaptchaVerifyCallback //리캡챠 체크박스 콜백
			, 'expired-callback' : reCaptchaExpiryCallback //리캡챠 체크박스 인증 만료 콜백
			, 'error-callback' : reCaptchaErrorCallback
		});
	}
};

//리캡챠 체크박스 콜백
function reCaptchaVerifyCallback(response) {
	reCAPTCHA_2_token = response;
	$("#commonRegLogin").append( $('<input>', { type: 'hidden', name: "reCAPTCHA_2_token", val: reCAPTCHA_2_token }) );
	if ($("#id").val() === "") {
		$("#noti_id_msg").html("아이디를 입력해주세요.");
		$("#noti_id_msg").parent().addClass("error");
		return false;
	} else if ($("#passwd").val() === "") {
		$("#noti_passwd_msg").html("비밀번호를 입력해주세요.");
		$("#noti_passwd_msg").parent().addClass("error");
		return false;
	}
	$.ajax({
		type:"post",
		data:{"token":reCAPTCHA_1_encToken, loginId:$("#id").val()},
		url: '/cust/cert/reCAPTCHA/validateToken.gs',
		async : false,
		success: function (res) {
			if(res === true) {
				GsBase.login.capchaShowOrSubmit();
			} else {
				alert("reCAPTCHA 정보가 유효하지 않습니다.\n다시 ID/PW 입력 후 로그인 시도해 주세요.");
				location.reload();
			}
		},
		error: function () {
			console.log("validateToken error");
		}
	});
};

//리캡챠 체크박스 인증 만료 콜백
function reCaptchaExpiryCallback() {
	$('#commonRegLogin input[name="reCAPTCHA_2_token"]').remove();
	reCAPTCHA_2_token = "";
	//열려있는 캡챠 레이어 닫기
	if ($("#captchaFlg").val() === "true" && $("#modal-capcha").hasClass("on")) {
		gs.captchaClose();
	}
};

//reCAPTCHA에 오류(일반적으로 네트워크 연결)가 발생하여 연결이 복원될 때까지 계속할 수 없는 경우 콜백 함수
function reCaptchaErrorCallback() {
	alert("서비스가 원활하지 않습니다. 잠시후 다시 시도해 주세요.");
	reCaptchaExpiryCallback();
	$('#reCAPTCHA-chbx').remove();
};

GsBase.closeLayer = function() {
	var srchLayer = new GsBase.modal('#srchLayer');
	srchLayer.remove("#srchLayer");
	
	try{
		var timer = CelphnCert.timerId;
		if(timer){
			clearTimeout(timer);
		}
	}catch(e){
		
	}
};